import {map} from 'lodash'
const LOAD = 'server-sts/sessions/LOAD';
const LOAD_SUCCESS = 'server-sts/sessions/LOAD_SUCCESS';
const LOAD_FAIL = 'server-sts/sessions/LOAD_FAIL';
const EDIT_START = 'server-sts/sessions/EDIT_START';
const EDIT_STOP = 'server-sts/sessions/EDIT_STOP';
const SAVE = 'server-sts/sessions/SAVE';
const SAVE_SUCCESS = 'server-sts/sessions/SAVE_SUCCESS';
const SAVE_FAIL = 'server-sts/sessions/SAVE_FAIL';
const CREATE = 'server-sts/sessions/CREATE';
const CREATE_SUCCESS = 'server-sts/sessions/CREATE_SUCCESS';
const CREATE_FAIL = 'server-sts/sessions/CREATE_FAIL';
const SEND_CREDENTIALS = 'server-sts/sessions/SEND_CREDENTIALS';
const SEND_CREDENTIALS_SUCCESS = 'server-sts/sessions/SEND_CREDENTIALS_SUCCESS';
const SEND_CREDENTIALS_FAIL = 'server-sts/sessions/SEND_CREDENTIALS_FAIL';
const CONSULT = 'server-sts/sessions/CONSULT';

const initialState = {
  loaded: false,
  loading: false,
  created: false,
  sessionCreatedError:false,
  editing: {},
  saveError: {},
  sending: {}
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        loading: true
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.result,
        error: null
      };
    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error
      }
    default:
      return state;
  }
}

export function isLoaded(globalState) {
  return globalState.sessions && globalState.sessions.loaded;
}



export function load() {
  return {
    promise: (session) => session.post('/session/load'),
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL]
  };
}


export function deleteSession(token) {
  return {
    types: [SAVE, SAVE_SUCCESS, SAVE_FAIL],
    promise: (session) => session.post('/session/deleteSession', {
      data: {token}
    })
  };
}
